import { Component, OnInit } from '@angular/core';
import { EnvService } from 'src/app/service/env.service';

@Component({
  selector: 'app-page-qr',
  templateUrl: './page-qr.component.html',
  styleUrls: ['./page-qr.component.scss']
})
export class PageQrComponent implements OnInit {

  constructor(public environment : EnvService) { }

  ngOnInit(): void {
  }

}
